import styled, { css } from "styled-components";
import {
  TabContentType,
  TabLableType,
  TabLableWrapperType,
  TabContentRenderType,
} from ".";
import { transition } from "project-config/style";
import { duration } from "project-config/style/transition";

const tabLabelStyle = (p: TabLableType) =>
  ({
    line: {
      common: css`
        position: relative;
        font-size: 12px;
        font-weight: 400;
        margin-right: ${(p) => (p.labelGap ? `${p.labelGap}px` : "24px")};
        &:hover {
          color: #e0edef;
        }
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          top: calc(100% + 6px);
          left: 0;
          width: 100%;
          height: 4px;
          opacity: 1;
          background: transparent;
          transition: ${transition("background", duration.shorter)};
        }
      `,
      normal: css`
        color: #8c9396;
      `,
      active: css`
        color: #e0edef;
        &::after {
          background: var(--main-color);
        }
      `,
    },
    card: {
      common: css`
        padding: 0 20px;
        font-size: 14px;
        font-weight: 600;
        &:first-child {
          border-left: none;
        }
        &:hover {
          color: #e0edef;
        }
      `,
      normal: css`
        color: #8c9396;
        background-color: transparent;
      `,
      active: css`
        color: #e0edef;
        background-color: ${(p) => p.theme["gray-4"]};
        border-left: 1px solid #404246;
        border-right: 1px solid #404246;
      `,
    },
    common: {
      common: css``,
      normal: css``,
      active: css``,
    },
  }[p.type]);

const tabLabelWrapperStyle = (p: TabLableWrapperType) =>
  ({
    line: css`
      border-bottom: 1px solid #404246;
      padding-bottom: 10px;
    `,
    card: css`
      height: 36px;
      line-height: 36px;
      border: 1px solid #404246;
      background-color: #18191b;
    `,
    common: css``,
  }[p.type]);

const tabContentStyle = (p: TabContentType) =>
  ({
    line: css`
      height: calc(100% - 60px);
    `,
    card: css`
      height: calc(100% - 36px);
    `,
    common: css``,
  }[p.type]);

export const TabsWrapper = styled.div<{ maxHeight: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: ${({ maxHeight }) => maxHeight};
`;
export const TabContent = styled.div<TabContentRenderType>`
  position: relative;
  width: 100%;
  ${(p) => tabContentStyle({ type: p.type })};
  display: ${(p) => (p.isShow ? "block" : "none")};
`;
export const TabLabelWrapper = styled.div<TabLableWrapperType>`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  ${(p) => tabLabelWrapperStyle(p)};
  &.task-detail-tabs {
    margin: 12px 12px 0;
    width: auto;
  }
`;
export const TabLabel = styled.div<TabLableType>`
  height: 100%;
  min-width: max-content;
  cursor: pointer;
  transition: ${transition("background")};
  ${(p) => tabLabelStyle(p)?.common};
  ${(p) => (p.active ? tabLabelStyle(p)?.active : tabLabelStyle(p)?.normal)};
`;
